export default __webpack_public_path__ + "3d1d519a8ca5c342108e899ade6e0b8d.png";